import { Component, inject, OnInit, Signal } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import translationsNL from '../../public/i18n/nl.json';
import { AuthService } from './services/auth.service';
import { LoaderComponent } from './components/ui/loader/loader.component';
import { LoaderService } from './services/loader.service';

import { ToastComponent } from './components/ui/toast/toast.component';
import { IsLoaderState } from './interfaces/is-loader-state';

@Component({
	selector: 'app-root',
	imports: [RouterOutlet, LoaderComponent, ToastComponent],
	templateUrl: './app.component.html',
})
export class AppComponent implements OnInit {
	private readonly translateService: TranslateService = inject(TranslateService);
	private readonly authService: AuthService = inject(AuthService);
	private readonly loaderService: LoaderService = inject(LoaderService);

	public loader: Signal<IsLoaderState> = this.loaderService.loader;

	ngOnInit(): void {
		this.setupTranslation();
		this.authService.autoLogin();
	}

	private setupTranslation(): void {
		this.translateService.addLangs(['nl']);
		this.translateService.setTranslation('nl', translationsNL);
		this.translateService.setDefaultLang('nl');
		this.translateService.use('nl');
	}
}
